export default "/images/menu-ico3.png?82d1fb52401d93ae4100acfcb743c23e";